
import { createTranslations } from '../../i18n/types';

export default createTranslations({
  en: {
    title: 'Winners',
    loading: 'Loading...',
    empty: 'No reward recipients yet',
    loadError: 'Failed to load history',
    timeJustNow: 'just now',
    timeMinutesAgo: '{{count}} min ago',
    timeHoursAgo: '{{count}} h ago',
    timeDaysAgo: '{{count}} d ago',
  },
  ru: {
    title: 'Победители',
    loading: 'Загрузка...',
    empty: 'Пока нет получателей награды',
    loadError: 'Не удалось загрузить историю',
    timeJustNow: 'только что',
    timeMinutesAgo: '{{count}} мин назад',
    timeHoursAgo: '{{count}} ч назад',
    timeDaysAgo: '{{count}} дн назад',
  },
  uz: {
    title: 'G\'oliblar',
    loading: 'Yuklanmoqda...',
    empty: 'Hali mukofot oluvchilar yo\'q',
    loadError: 'Tarixni yuklab bo\'lmadi',
    timeJustNow: 'hozirgina',
    timeMinutesAgo: '{{count}} daq oldin',
    timeHoursAgo: '{{count}} soat oldin',
    timeDaysAgo: '{{count}} kun oldin',
  },
});
